module.exports = __webpack_public_path__ + "fonts/display-thin.a205a6a3.woff2";